import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, createJSONStorage } from 'zustand/middleware';

// Import helpers
import { getCurrentTime } from 'helpers/time';

type Store = {
	time: string;
	setCurrentTime: VoidFunction;
};

export const useCurrentTime = create<Store>()(
	immer(
		persist(
			(set) => ({
				time: '',
				setCurrentTime: () => {
					set((state) => {
						state.time = getCurrentTime();
					});
				}
			}),
			{
				name: 'time',
				storage: createJSONStorage(() => sessionStorage)
			}
		)
	)
);
